<template>
  <form-block
    v-model="entity.activity_management"
    :title='tr("Activity management")'
    :description='tr("Keep control of automation activities! Anyone set in the \"Members to be notified about activities\" will receive a notification with an option to approve or reject before the automation executes an activity.")'
    switchable
    :disabled="disabled"
  >
    <div v-if="entity.activity_management && !disableBlockInAiMode" class="flex flex-col gap-1.5">
      <ui-label>{{ tr('Interpretation of the lack of instruction as') }}</ui-label>
      <select-field
        v-model="entity.activity_management_auto_handling"
        :options="autoHandlingOptions"
        :reduce="(obj) => obj.value"
        :aria-label="tr('Interpretation of the lack of instruction as')"
        :disabled="disabled"
      />
    </div>

    <div v-if="entity.activity_management_auto_handling !== null && !disableBlockInAiMode" class="flex flex-col gap-1.5">
      <ui-label>{{ tr('Deadline for waiting for instructions before automatic action') }}</ui-label>
      <select-field
        v-model="entity.activity_management_auto_handling_after"
        :options="autoHandlingAfterOptions"
        :reduce="(obj) => obj.value"
        :aria-label="tr('Deadline for waiting for instructions before automatic action')"
        :disabled="disabled"
      />
    </div>
  </form-block>
</template>

<script>
import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';
import SelectField from '@/ui/components/SelectField.vue';
import { getIntervalOptions } from '@/utils/date.js';

export default {
  name: 'ActivityManagementBlock',
  components: {
    SelectField,
  },
  mixins: [ RuleFormBlockMixin ],
  props: {
    disableBlockInAiMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    hasNotifiableUsers() {
      return this.entity.notifiable_users.length !== 0;
    },
    autoHandlingOptions() {
      return [
        {
          label: 'Keep waiting - no automatic action should be taken',
          value: null,
        },
        {
          label: 'Auto-approve',
          value: 'accept',
        },
        {
          label: 'Auto-reject',
          value: 'reject',
        },
      ];
    },
    autoHandlingAfterOptions() {
      return getIntervalOptions(this.tr);
    },
  },
  watch: {
    hasNotifiableUsers(val) {
      if (!val) {
        this.entity.activity_management = false;
      }
    },
    'entity.activity_management'(val) {
      if (!val) {
        this.entity.activity_management_auto_handling = null;
      }
    },
    'entity.activity_management_auto_handling'(val) {
      if (val !== null) {
        this.entity.activity_management_auto_handling_after = 12 * 60;
      }
      else {
        this.entity.activity_management_auto_handling_after = null;
      }
    },
  },
};
</script>
